import type { PrioritiesEntityState } from '../../reducers/entities/priorities/types.tsx';
import type { State } from '../../types.tsx';
import { getEntities } from '../entities/index.tsx';

export const getPriorities = (state: State): PrioritiesEntityState => getEntities(state).priorities;
